import { BrandingLogoResponse, UploadBrandingLogoInput } from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const uploadBrandingLogo = async ({
  file,
  type,
}: UploadBrandingLogoInput) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("branding_type", type);
    const url = "/v2/controlCenter/msp/branding";
    const response = await axiosClient.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    const resdata = response.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteBrandingLogo = async (type: "logo" | "wordmark") => {
  try {
    const url = `/v1/controlCenter/msp/branding/${type}`;
    const response = await axiosClient.delete(url);
    const resdata = response.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getBrandingLogo = async (): Promise<
  BrandingLogoResponse[] | undefined
> => {
  try {
    const url = "/v1/controlCenter/msp/branding";
    const response = await axiosClient.get(url);
    const resdata = response.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
